import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import {
  ViewerAsset,
  ViewerLiability
} from '../../../../../../core/models/api.models';
import {
  formatAssetHolderShares,
  formatCurrency,
  formatDate,
  formatHolderLabel,
  formatLiabilityLabel,
  formatText,
  parseAdditionalFields
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-assets-section',
  imports: [InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-assets-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerAssetsSectionComponent {
  readonly assets = input.required<ViewerAsset[]>();
  readonly liabilities = input.required<ViewerLiability[]>();

  protected readonly formatText = formatText;
  protected readonly formatDate = formatDate;
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatHolderLabel = formatHolderLabel;
  protected readonly formatAssetHolderShares = formatAssetHolderShares;
  protected readonly formatLiabilityLabel = formatLiabilityLabel;
  protected readonly parseAdditionalFields = parseAdditionalFields;

  protected getLinkedLiabilities(assetId: number): ViewerLiability[] {
    return this.liabilities().filter(liability => liability.linkedAssetId === assetId);
  }
}
